import { Component, OnInit, ViewChild } from '@angular/core';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { SelectedQnrService } from '../shared/services/selected-qnr.service';
import { TabsDataService } from '../shared/services/tabs-data.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { RenderZingChartService } from "../shared/services/render.zingchart.service";

import * as L from 'leaflet';
import { ToastyService, ToastOptions } from 'ng2-toasty';

@Component({
  selector: 'app-analytics-survey',
  templateUrl: './analytics-survey.component.html',
  styleUrls: ['./analytics-survey.component.css']
})
export class AnalyticsSurveyComponent implements OnInit {

  qID: any;
  adminID: any;
  public selectQnr = 'No survey selected';
  public qnrList = [];
  repeaterFrmList = [];
  subFrmList = [];
  showLoader: boolean;
  noQnrSelected: boolean;
  noDataCollected: boolean;
  selectRepeaterForm = 'No Repeater-Form Available';
  SelectedSubForm = 'No Sub-Form Available';
  qnr: any;
  linksInAnswer = [];
  // MatPaginator Output
  pageEvent: PageEvent;
  @ViewChild('AnalyticsQuestionPaginator') paginator: MatPaginator;
  noOfQuestions;
  selectQuestionPattern;
  responseAnswers;
  NoQuestionDataAvailable = true;
  textList = [];
  popupIcon = L.icon({
    iconUrl: 'assets/images/marker-unselected.svg',
  });
  map;
  markersArray = [];
  onClickimages = false;
  questionText = '';
  responsesCount = 0;
  documents = [];
  selectedVersion;
  versions = [];
  numVersionResponses = [];
  loaderOfDropdown: boolean = false;

  constructor(private restApiService: RestApiService, private selectedQnrService: SelectedQnrService, private tabsDataService: TabsDataService, private createChart: RenderZingChartService, private toastyService: ToastyService) {
  }

  ngOnInit() {
    this.initializeData();
  }

  async initializeData(){
    await this.getQnrList();
    this.qnr = this.selectedQnrService.getQnr();
    if (this.qnr) {
      this.getSurveyAnalytics(this.qnr, this.selectedQnrService.getSelectionType());
    }
    else {
      this.showLoader = false;
      this.noQnrSelected = true;
      this.noDataCollected = false;
    }
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  onPageChange(event) {
    // console.log(event);
    this.pageEvent = event;
    let i = this.pageEvent.pageIndex;
    this.responsesCount = 0;
    let result;

    if (this.qnr != undefined && this.qnr.question[this.pageEvent.pageIndex]['Qn'] != undefined) {
      let selectedQues = this.qnr.question[this.pageEvent.pageIndex];
      // console.log(selectedQues);
      this.questionText = selectedQues['Qn_In'] + '. ' + selectedQues['Qn'] + ' (' + selectedQues['Qn_Disp_Value'] + ')';
      switch (selectedQues['Qn_Type']) {
        case 'Subjective':
        case 'TextArea':
          this.selectQuestionPattern = 'textListType';
          break;
        case 'Radio':
        case 'Selected Dropdown':
          this.selectQuestionPattern = 'radioListType';
          break;
        case 'Checkbox':
          this.selectQuestionPattern = 'checkboxListType';
          break;
        case 'Video':
          this.selectQuestionPattern = 'videoType';
          break;
        case 'Audio':
          this.selectQuestionPattern = 'audioType';
          break;
        case 'Picture Input':
          this.selectQuestionPattern = 'imageType';
          break;
        case 'CalendarWithDate':
        case 'Calendar':
          this.selectQuestionPattern = 'calendarType';
          break;
        case 'Map':
          this.selectQuestionPattern = 'mapType';
          break;
        case 'Rating':
          this.selectQuestionPattern = 'ratingType';
          break;
        case 'Emoji':
          this.selectQuestionPattern = 'emojiType';
          break;
        case 'Rank':
          this.selectQuestionPattern = 'rankType';
          break;
        case 'Repeater_QT':
          this.selectQuestionPattern = 'numberType';
          break;
        case 'Button':
          this.selectQuestionPattern = 'CascadingType';
          break;
        case 'Document':
          this.selectQuestionPattern = 'docType';
          break;
        case 'Time':
          this.selectQuestionPattern = 'timeType';
          break;
        default:
          this.selectQuestionPattern = null;
      }
    }

    if (this.responseAnswers == undefined || this.responseAnswers[i + 1] == undefined) {
      this.NoQuestionDataAvailable = true;
      this.selectQuestionPattern = null;
      return;
    }
    else {
      this.NoQuestionDataAvailable = false;
      result = this.responseAnswers[i + 1];
    }
    // console.log(result);
    if (this.qnr != undefined && this.qnr.question != undefined && this.qnr.question[i] != undefined && this.qnr.question[i].Qn_Type != undefined) {
      if (this.selectQuestionPattern == 'textListType') {
        this.textList = [];
        let text = '';
        for (let data in result) {
          if (result[data] != -1 && result[data]) {
            text += result[data] + ' '; // for wordCloud in right
            this.textList.push(result[data]); //for list in left
          }
        }
        this.responsesCount = this.textList.length;
        this.createChart.wordCloudChart(text, 'wordChart');
      }
      else if (this.selectQuestionPattern == 'checkboxListType') {
        this.responsesCount = null;
        let dataChart = [];
        for (let data in result) {
          let chartValue = { "values": [], "text": data };
          chartValue.values.push(result[data]);
          dataChart.push(chartValue);
          this.responsesCount += result[data];
        }
        this.createChart.barChart(dataChart, [], 'numberBarChart');
      }
      else if (this.selectQuestionPattern == 'videoType' || this.selectQuestionPattern == 'imageType' || this.selectQuestionPattern == 'audioType') {
        this.linksInAnswer = [];
        for (let data in result) {
          if (result[data] != -1 && result[data])
            this.linksInAnswer.push(result[data])
        }
        this.responsesCount = this.linksInAnswer.length;
      }
      else if (this.selectQuestionPattern == 'radioListType') {
        this.responsesCount = 0;
        //pie chart
        let dataChart = [];
        for (let data in result) {
          let chartValue = { "values": [], "text": data.toUpperCase() };
          if (typeof (result[data]) == 'string') {
            chartValue.values.push(parseInt(result[data]));
            this.responsesCount += parseInt(result[data]);
          }
          else {
            this.responsesCount += result[data];
            chartValue.values.push(result[data]);
          }
          dataChart.push(chartValue);
        }

        let config = this.createChart.pieChartsCombinedConfig(dataChart, [{
          "x": "45%", "y": "32%", "width": "10%", "text": "", "font-size": 20
        }], undefined, "0%");

        this.createChart.renderZingCharts('pieChart', config);
      }
      else if (this.selectQuestionPattern == 'calendarType') {
        let keys = Object.keys(result).sort();
        this.responsesCount = 0;
        let values = [];

        let xLabels = [];
        for (let data in keys) {
          if (parseInt(keys[data]) != -1 && keys[data]) {
            xLabels.push(keys[data]);
            this.responsesCount += parseInt(result[keys[data]]);
            values.push(parseInt(result[keys[data]]));
          }
        }
        //line chart
        let config = this.createChart.lineChart({
          "data": [{ "values": values }], "Xlabel": xLabels
        });
        this.createChart.renderZingCharts('dateLineChart', config);
      }
      else if (this.selectQuestionPattern == 'mapType') {
        // mapAnalysis
        if (!this.map) {
          this.map = L.map('mapAnalysis').setView([28.530174367202772, 77.21844629033777], 13);
          L.tileLayer('http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
            attribution: '',
            maxZoom: 25,
            id: 'mapbox/streets-v11',
            accessToken: 'your.mapbox.access.token'
          }).addTo(this.map);
        }
        else {
          for (let marker in this.markersArray) {
            this.map.removeLayer(this.markersArray[marker]);
          }
          this.markersArray = [];
        }
        for (let data in result) {
          if (result[data] != null) {
            let latLngJson = JSON.parse(result[data]);
            if (parseInt(data) == 0) {
              this.map.panTo(new L.LatLng(latLngJson.lat, latLngJson.lng))
            }
            this.markersArray.push(L.marker([latLngJson.lat, latLngJson.lng], { draggable: false }).setIcon(this.popupIcon).addTo(this.map));
            // mahima.... see if there is a request of clusters
          }
        }
        this.responsesCount = this.markersArray.length;

      }
      else if (this.selectQuestionPattern == 'ratingType') {
        let dataChart = [];
        for (let i = 1; i <= 5; i++) {
          let chartValue = { "values": [], "text": i.toString() };
          if (result[i]) {
            this.responsesCount += parseInt(result[i]);
            chartValue.values.push(parseInt(result[i]));
          }
          else {
            chartValue.values.push(0);
          }
          dataChart.push(chartValue);
        }
        this.createChart.ratingBarChart(dataChart, 'ratingChart');
      }
      else if (this.selectQuestionPattern == 'emojiType') {
        let dataChart = [];
        let chartValue = { "values": [] };
        let sentimentsArray = ["Highly satisfied", "Happy", "Satisfied", "Content", "Highly dissatisfied"];
        for (let sentiment in sentimentsArray) {
          if (result[sentimentsArray[sentiment]]) {
            this.responsesCount += parseInt(result[sentimentsArray[sentiment]]);
            chartValue.values.push(parseInt(result[sentimentsArray[sentiment]]));
          }
          else {
            chartValue.values.push(0);
          }
        }
        dataChart.push(chartValue);
        this.createChart.emojiBarChart(dataChart, 'emojiChart');
      }
      else if (this.selectQuestionPattern == 'rankType') {
        let dataChart = [];
        let resultKeys = Object.keys(result);
        for (let i in resultKeys) {
          i = resultKeys[i]
          let chartValue = { "values": [], "text": i };
          if (result[i]) {
            let arrayOfOptionsValue = this.qnr.question[this.pageEvent.pageIndex].Opt_Name;
            for (let option in arrayOfOptionsValue) {
              if (result[i][arrayOfOptionsValue[option]]) {
                this.responsesCount += parseInt(result[i][arrayOfOptionsValue[option]]);
                chartValue.values.push(parseInt(result[i][arrayOfOptionsValue[option]]));
              }
              else {
                chartValue.values.push(0);
              }
            }
          }
          else {
            chartValue.values.push(0);
          }
          dataChart.push(chartValue);
        }
        this.createChart.rankBarChart(dataChart, 'rankChart');
      }
      else if (this.selectQuestionPattern == 'CascadingType') {
        this.responsesCount = 0;
        let sunchartData: SunBurstChartDataModel[] = [{ id: 'Main', text: '', parent: '' }];

        let xLabels = [];
        let parentsAtlevel = [[], [], [], []];
        let indexArray = [];
        for (let data in result) {
          if (result[data] && result[data] != -1) {
            let resultLine = JSON.parse(result[data]);
            if (typeof (resultLine) == 'object' && resultLine.length && resultLine.length > 0) {
              let index = 0;
              let createNew: boolean;
              this.responsesCount += 1;

              while (index < 4) {
                if (resultLine[index] && resultLine[index] != 'null' && resultLine[index] != -1) {
                  if (parentsAtlevel[index].indexOf(resultLine[index]) > -1) {

                    if (index == 3) {
                      let indexOfValueInParentArray = parentsAtlevel[index].indexOf(resultLine[index])
                      sunchartData[indexArray[indexOfValueInParentArray]]['value']++;
                    }
                    index++;
                  }
                  else {
                    parentsAtlevel[index].push(resultLine[index]);
                    createNew = true;
                  }
                  if (createNew) {
                    if (index == 0) {
                      sunchartData.push({ id: resultLine[index], text: resultLine[index], parent: "Main" })
                    }
                    else if (index > 0 && index < 3) {
                      sunchartData.push({ id: resultLine[index], text: resultLine[index], parent: resultLine[index - 1] })
                    }
                    else {
                      indexArray.push(sunchartData.length);
                      sunchartData.push({ 'value': 1, id: resultLine[index], text: resultLine[index], parent: resultLine[index - 1] });
                    }
                    index++;
                  }
                }
                else {
                  index++;
                  break;
                }
              }
            }
          }
        }

        let config = this.createChart.sunBurstPie({
          "data": sunchartData
        });
        this.createChart.renderZingCharts('SunBurstChart', config);
      }
      else if (this.selectQuestionPattern == 'docType') {
        this.documents = [];
        for (let data in result) {
          if (result[data] && result[data] != null && result[data] != -1 && result[data] != "-1") {
            let tempTypeArr = result[data].split('.');
            let tempUrlParts = result[data].split('/');
            let type = tempTypeArr[tempTypeArr.length - 1];
            let fileName = tempUrlParts[tempUrlParts.length - 1];
            if (type == 'pdf')
              this.documents.push({ 'fileName': fileName, 'type_img': 'pdf_response' })
            else if (type == 'doc' || type == 'docx')
              this.documents.push({ 'fileName': fileName, 'type_img': 'doc_response' })
            else if (type == 'ppt' || type == 'pptx')
              this.documents.push({ 'fileName': fileName, 'type_img': 'ppt_response' })
            else if (type == 'xls' || type == 'xlsx')
              this.documents.push({ 'fileName': fileName, 'type_img': 'excel_response' })
            else if (type == 'txt')
              this.documents.push({ 'fileName': fileName, 'type_img': 'txt_response' })
            else
              this.documents.push({ 'fileName': fileName, 'type_img': 'default_doc_response' })
          }
        }
        this.responsesCount = this.documents.length;
      }
      else if(this.selectQuestionPattern == 'timeType'){
        if(this.qnr.question[i].Is_Range){
          let rangeTimeRegexp = new RegExp('(1[012]|[1-9]):[0-5][0-9](\\s)?(am|pm|AM|PM) - (1[012]|[1-9]):[0-5][0-9](\\s)?(am|pm|AM|PM)');
          let dataChart = [];
          for(let data in result){
            if (result[data] && result[data] != null && result[data] != -1 && result[data] != "-1") {
              if(rangeTimeRegexp.test(result[data])){
                let splitMinMaxTime = result[data].split(' - ');
                let valuemin = this.convertTo24HrFormat(splitMinMaxTime[0]);
                let valuemax = this.convertTo24HrFormat(splitMinMaxTime[1]);
                dataChart.push([valuemin, valuemax]);
                this.responsesCount ++;
              }
            }
          }
          //range chart
          let config = this.createChart.rangeChart({
            "data": [{ "values": dataChart }]
          });
          this.createChart.renderZingCharts('timeChart', config);
        }
        else{
          let regexp = new RegExp('(1[012]|[1-9]):[0-5][0-9](\\s)?(am|pm|AM|PM)');
          let dataChart = new Array(24);
          dataChart.fill(0);
          for(let data in result){
            if (result[data] && result[data] != null && result[data] != -1 && result[data] != "-1") {
              if(regexp.test(result[data])){
                let value = this.convertTo24HrFormat(result[data]);
                dataChart[value] += 1;
                this.responsesCount ++;
              }
            }
          }
          //line chart
          let config = this.createChart.lineChart({
            "data": [{ "values": dataChart }], "Xlabel": Object.keys(dataChart) , "XlabelText" : 'In 24 hr Format'
          });
          this.createChart.renderZingCharts('timeChart', config);
        }
      }
      else if (this.selectQuestionPattern == 'numberType' || this.qnr.question[i].Qn_Type.indexOf('WholeNumMax') != -1 || this.qnr.question[i].Qn_Type.indexOf('DecimalMax') != -1 || this.qnr.question[i].Qn_Type.indexOf('NaturalNum') != -1) {
        this.selectQuestionPattern = 'numberType';
        if(this.qnr.question[i].Qn_Type.indexOf('WholeNumMax') != -1 && this.qnr.question[i].Is_Range){
          let keys = Object.keys(result).sort();
          this.responsesCount = 0;
          let values = [];
          this.textList = [];
  
          let xLabels = [];
          for (let data in keys) {
            if (parseInt(keys[data]) != -1 && keys[data]) {
              xLabels.push(keys[data]);
              let rangevalues = keys[data].split('-');
              for (let i = 0; i < parseInt(result[keys[data]]); i++) {
                values.push([parseInt(rangevalues[0]), parseInt(rangevalues[1])]);
              }
              this.responsesCount += parseInt(result[keys[data]]);
            }
          }
          this.textList = xLabels;
          //range chart
          let config = this.createChart.rangeChart({
            "data": [{ "values": values }]
          });
          this.createChart.renderZingCharts('lineChart', config);
        }
        else{
          let keys = Object.keys(result).sort();
          this.responsesCount = 0;
          let values = [];
          this.textList = [];

          let xLabels = [];
          for (let data in keys) {
            if (parseInt(keys[data]) != -1 && keys[data]) {
              xLabels.push(keys[data]);
              values.push(parseInt(result[keys[data]]));
              this.responsesCount += parseInt(result[keys[data]]);
            }
          }
          this.textList = xLabels;
          //line chart
          let config = this.createChart.lineChart({
            "data": [{ "values": values }], "Xlabel": xLabels
          });
          this.createChart.renderZingCharts('lineChart', config);
        }
      }
      else if (this.qnr.question[i].Qn_Type.indexOf('MobileNum') != -1) {
        this.selectQuestionPattern = 'mobilenumberType';
        this.textList = result;
        this.responsesCount = this.textList.length;
      }
      if (this.responsesCount == 0) {
        this.NoQuestionDataAvailable = true;
        this.selectQuestionPattern = null;
      }
    }
  }

  setSelectedVersionNull(qnr){
    if(qnr.numResponses != 0){
      this.selectedVersion = null;
      return;
    }
  }
  getSurveyAnalytics(qnr, selectionType) {
    if(qnr.numResponses == 0){
      return;
    }
    if (qnr.numResponses != 0) {
      this.paginator._pageIndex = 0;
      this.onClickimages = false;
      this.qID = qnr.qID;
      this.noOfQuestions = qnr.question.length;
      this.adminID = qnr.adminID;

    this.showLoader = true;
    this.noQnrSelected = false;
    this.noDataCollected = false;
    if (selectionType == 'SubFormSelection') {
      this.SelectedSubForm = qnr.surveyName;
    }
    else {
      this.selectQnr = qnr.surveyName;
    }
    this.qnr = qnr;
    this.versions = qnr.versions;
    this.numVersionResponses = qnr.numVersionResponses;
    this.selectedVersion = this.selectedVersion ? this.selectedVersion : (this.versions ? this.versions[this.versions.length - 1] : []);
    this.selectedQnrService.setQnr(qnr, selectionType);
    this.restApiService.getAggDataForAnalyticsService(qnr.qID, qnr.adminID, qnr.child_group,this.selectedVersion).subscribe(
      result => {
        this.showLoader = false;
        let api_result = result.result;
        if (result.success) {
          if (api_result) {
            this.responseAnswers = api_result;
            // To load the data of first page 
            this.onPageChange({ pageIndex: 0, pageSize: 1, length: 12 });
          }
          else {
            this.noDataCollected = true;
          }
          if(result.question){
            this.qnr.question = result.question;
            this.noOfQuestions = qnr.question.length;
          }
          if (selectionType != "SubFormSelection") {
            if (result.subArray) {
              this.subFrmList = result.subArray;
              this.SelectedSubForm = 'No Sub-Form Selected';
            }
            else {
              this.subFrmList = [];
              this.SelectedSubForm = 'No Sub-Form Available';
            }
          }
        }
        else {
          this.responseAnswers = null;
          this.questionText = '';
          this.responsesCount = 0;
          this.noDataCollected = true;
          var toastOptions: ToastOptions = {
            title: "Error while loading data.Please try again later.",
            msg: result.msg,
            showClose: true,
            timeout: 3000,
            theme: 'bootstrap'
          };
          this.toastyService.error(toastOptions);
        }
      });
    }
    else {
      this.showLoader = false;
      this.noDataCollected = true;
      this.selectQnr = qnr.surveyName;
      this.noQnrSelected = false;
      this.versions = [];
    }
  }

  async getQnrList() {

    if (!this.tabsDataService.hasSurveyTabDataTobeUpdated()) {
      this.qnrList = this.tabsDataService.getSurveyTabData();
    }
    else {
      this.loaderOfDropdown = true;
      await this.restApiService.getQnrListService().subscribe(
        result => {
        this.loaderOfDropdown = false;
          this.qnrList = result.result;
        });
    }
  }

  openLinkInNewWindow(link) {
    if (link != null && link != -1 && link != '-1')
      window.open(link);
  }
  
  convertTo24HrFormat(time){
    let parts = [];
    let timeclock:string[]  = time.split(' ');
    let timevalues = time.split(':')
    parts.push(timeclock[1].toLowerCase());
    parts.push(parseInt(timevalues[0]));
    parts.push(parseInt(timevalues[1]));
    return parts[1] + (parts[0] == 'pm' ? 12 : 0);
  }

  getParticularVersionQuestions(indexOfVersion) {
    if(this.numVersionResponses[indexOfVersion] > 0){
      this.getSurveyAnalytics(this.qnr, this.selectedQnrService.getSelectionType());
    }
    else{
      this.noDataCollected = true;
      // "The numVersionResponses indicates that the count ofresponses for this version is zero"
    }

  }

}

interface SunBurstChartDataModel {
  'value'?: number,
  id?: string,
  text?: string,
  parent?: string
};



// WEBPACK FOOTER //
// ./src/app/analytics-survey/analytics-survey.component.ts